import React from "react";
import type { ReactNode, ReactElement } from "react";

import cn from "classnames";

import { Gap } from "../../../../helpers/common/Gap/Gap";

import classes from "../UniBoxMain.styl";

type RowType = "top-row" | "middle-row" | "bottom-row";

type RenderRowWithSlots = {
    type: RowType;
    slots: ReactElement[];
};

/**
 * Рендерит строку со слотами, если хотя бы один слот существует.
 * @param slots - массив слотов для рендеринга.
 * @param type - тип слота.
 * @returns JSX строки со слотами или null, если все слоты пустые.
 */
export const renderRowWithSlots = ({
    slots,
    type,
}: RenderRowWithSlots): ReactNode => {
    const existingSlots = slots.filter((slot) => !!slot);

    if (existingSlots.length === 0) {
        return null;
    }
    const slotGapClassName = classes[`${type}-slot-gap-values`];

    return (
        <Gap
            className={cn(
                classes["uni-box-main-row"],
                classes["uni-box-main-row-gap-values"],
            )}
            contentClassName={cn(
                classes["uni-box-main-row-gap-container"],
                slotGapClassName,
                classes[type],
            )}
        >
            {existingSlots.map((slot, index) => (
                <div
                    key={index}
                    className={cn(
                        classes["uni-box-main-slot-wrapper"],
                        slotGapClassName,
                    )}
                >
                    {slot}
                </div>
            ))}
        </Gap>
    );
};
